import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultDescription: description
        defaultImageUrl
        defaultKeywords: keywords
        defaultTitle: title
        siteUrl
        titleTemplate
      }
    }
  }
`;

const DEFAULT_TYPE = 'website';

const Seo = (props) => {
  const { children, seo: rawSeo, noindex } = props;
  const {
    site: { siteMetadata },
  } = useStaticQuery(query);
  const {
    defaultDescription,
    defaultImageUrl,
    defaultKeywords,
    defaultTitle,
    siteUrl,
    titleTemplate,
    twitterUsername,
  } = siteMetadata;

  const {
    canonical,
    description,
    imageUrl,
    keywords,
    title: titleRaw,
    type,
  } = rawSeo || {};
  const title = titleTemplate.replace('%s', titleRaw || defaultTitle);

  const seo = {
    canonical: canonical ? `${siteUrl}${canonical}` : null,
    description: description || defaultDescription,
    keywords: keywords || defaultKeywords,
    imageUrl: imageUrl || defaultImageUrl,
    title,
    type: type || DEFAULT_TYPE,
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta name="robots" content={noindex ? 'noindex' : 'all'} />
      {seo.canonical && <link rel="canonical" href={seo.canonical} />}
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />
      <meta name="image" content={seo.imageUrl} />
      <meta property="og:site_name" content="Achievable" />
      {seo.canonical && <meta property="og:url" content={seo.canonical} />}
      <meta property="og:title" content={seo.title} />
      <meta property="og:type" content={seo.type} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.imageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      {twitterUsername && <meta name="twitter:creator" content={twitterUsername} />}
      <meta name="twitter:site" content="@AchievablePrep" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.imageUrl} />
      {children}
    </>
  );
};

export default Seo;
